import msgs from "../components/Pages/SummaryView/messages";

const isCompound = record => [true, 'yes'].includes(record.isCompound);
const isNotCompound = record => [false, 'no'].includes(record.isCompound);

const isNDC = record => [true, 'ndc'].includes(record.searchBy);

const isNotLegacy = (record) => {
    return record.attachments?.some(f => f.name?.includes("PA_SUMMARY"))
}
const isLegacy = record => !record.attachments?.some(f => f.name?.includes("PA_SUMMARY")) || !record.attachments.length

const diagnosisCodes = record => record.diagnosisCodes && record.diagnosisCodes.map( c => c.diagnosisCd ).join(", ");

const showProviderType = (record, operation, appContext) => {
    if(operation === 'create'){
        return appContext.provider.providerDesc
    }
    return record.providerType
}

const dawCode = record => {
    const val = record.dawSelectionCode
    if(!val) return

    if(val.includes('0')){
        return 'No Product Selection Ind'
    }
    else if( val.includes('1') ){
        return 'No Substitution-Prescriber'
    }
    else if( val.includes('2') ){
        return 'Dispensed Patient Request'
    }
    else if( val.includes('3') ){
        return 'Dispensed Pharmacist Selected'
    }
    else if( val.includes('4') ){
        return 'Generic Drug Not in Stock'
    }
    else if( val.includes('5') ){
        return 'Dispensed Brand as Generic'
    }
    else if( val.includes('6') ){
        return 'Override'
    }
    else if( val.includes('7') ){
        return 'No Substitue-Brand by Law'
    }
    else if( val.includes('8') ){
        return 'Generic Drug Unavailable'
    }
    else if( val.includes('9') ){
        return 'Other'
    }
    else{
        return `Unknown Code: ${val}`
    }
}

const beneficiaryLoc = record => {
    const val = record.beneficiaryLocation

    if(!val) return

    if( val.includes('01') ){
        return 'Pharmacy'
    }
    else if( val.includes('12') ){
        return 'Home'
    }
    else if( val.includes('13') ){
        return 'Assisted Living Facility'
    }
    else if( val.includes('14') ){
        return 'Group Home'
    }
    else if( val.includes('20') ){
        return 'Urgent Care Facility'
    }
    else if( val.includes('21') ){
        return 'Inpatient Hospital'
    }
    else if( val.includes('22') ){
        return 'Outpatient Hospital'
    }
    else if( val.includes('23') ){
        return 'Emergency Room'
    }
    else if( val.includes('24') ){
        return 'Ambulatory Surgical Cente'
    }
    else if( val.includes('25') ){
        return 'Skilled Nursing Facility'
    }
    else if( val.includes('32') ){
        return 'Nursing Facility'
    }
    else if( val.includes('33') ){
        return 'Custodial Care Facility'
    }
    else if( val.includes('34') ){
        return 'Hospice'
    }
    else if( val.includes('53') ){
        return 'Nursing Facility (ICF or LTC)'
    }
    else if( val.includes('54') ){
        return 'Intermediate Care Facility'
    }
    else if( val.includes('55') ){
        return 'Long term Care Facility'
    }
    else if( val.includes('56') ){
        return 'Other Location, not specified'
    }
    else{
        return `Unknown Location: ${val}`
    }
}

const providerPrescriberValue = (record) =>
  record.prescriberFirstName !== "" && record.prescriberFirstName !== null;

export default  [
    {
        title: {
            text: msgs.providerInformation.text,
            id: msgs.providerInformation.id
        },

        items: [
            {"label":{"id":"providerNameLabel ", "text": msgs.providerName.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "providerNameValue", "property": "providerName" , "size": { "xs": 12, "md": 2}}},
            {"label":{"id":"providerTypeLabel ", "text": msgs.providerType.text, "size": { "xs": 12, "md": 2 } }, renderFn: showProviderType, "value": {"id": "providerTypeValue", "property": "providerType" , "size": { "xs": 12, "md": 2}}},
            {"label":{"id":"npiLabel ", "text": msgs.npi.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "npiValue", "property": "npiNumber" , "size": { "xs": 12, "md": 2}}},
            {"label":{"id":"providerFaxLabel ", "text": "Provider Fax#:", "size": { "xs": 12, "md": 2 } }, "value": {"id": "providerPrescriberValue",  "property": "providerFax" , "size": { "xs": 12, "md": 2}}},
            {"label":{"id":"providerPhoneLabel ", "text": "Provider Phone#:", "size": { "xs": 12, "md": 2 } }, "value": {"id": "providerPrescriberValue",  "property": "providerPhone" , "size": { "xs": 12, "md": 6}}},
            {"label":{"id":"providerPrescriberLabel ", "text": "Prescriber NPI:", "size": { "xs": 12, "md": 2 } }, "value": {"id": "providerPrescriberValue",  "property": "prescriberNPI" , "size": { "xs": 12, "md": 2}}, toggleFn: providerPrescriberValue},
            {"label":{"id":"providerPrescriberLabel ", "text": "Prescriber First Name:", "size": { "xs": 12, "md": 2 } }, "value": {"id": "providerPrescriberValue", "property": "prescriberFirstName" , "size": { "xs": 12, "md": 2}}, toggleFn: providerPrescriberValue},
            {"label":{"id":"providerPrescriberLabel ", "text": "Prescriber Last Name:", "size": { "xs": 12, "md": 2 } }, "value": {"id": "providerPrescriberValue", "property": "prescriberLastName" , "size": { "xs": 12, "md": 2}}, toggleFn: providerPrescriberValue},
            {"label":{"id":"providerPrescriberLabel ", "text": "Fax #:", "size": { "xs": 12, "md": 2 } }, "value": {"id": "providerPrescriberValue", "property": "prescriberFax" , "size": { "xs": 12, "md": 2}}, toggleFn: providerPrescriberValue},
            {"label":{"id":"providerPrescriberLabel ", "text": "Phone #:", "size": { "xs": 12, "md": 2 } }, "value": {"id": "providerPrescriberValue",  "property": "prescriberPhone" , "size": { "xs": 12, "md": 2}}, toggleFn: providerPrescriberValue},
        ]
    },
    {
        title: {
            text: msgs.submitterInformation.text,
            id: msgs.submitterInformation.id
        },
        items: [
            {"label":{"id":"requesterFirstNameLabel ", "text": msgs.submitterFirstName.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "submitterFirstNameValue", "property": "submitterFirstName" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"requesterLastNameLabel ", "text": msgs.submitterLastName.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "submitterLastNameValue", "property": "submitterLastName" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"contactPhoneLabel ", "text": msgs.submitterContactPhone.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "submitterContactPhoneValue", "property": "submitterContactPhone" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"hippaSecureFaxNumberLabel ", "text": msgs.submitterHippaSecureFaxNumber.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "submitterHippaSecureFaxNumberValue", "property": "submitterHippaSecureFax" , "size": { "xs": 12, "md": 4}}},
        ]
    },
    {
        title: {
            text: msgs.beneficiaryInformation.text,
            id: msgs.beneficiaryInformation.id
        },
        items: [
            {"label":{"id":"beneficiaryFirstNameLabel ", "text": msgs.beneficiaryFirstName.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "beneficiaryFirstNameValue", "property": "beneficiaryFirstName" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"beneficiaryLastNameLabel ", "text": msgs.beneficiaryLastName.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "beneficiaryLastNameValue", "property": "beneficiaryLastName" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"beneficiaryLocation ", "text": msgs.beneficiaryLocation.text, "size": { "xs": 12, "md": 2 } }, renderFn: beneficiaryLoc, "value": {"id": "beneficiaryLocation", "property": "beneficiaryLocation" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"beneficiaryIDLabel ", "text": msgs.beneficiaryID.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "beneficiaryIDValue", "property": "beneficiaryID" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"beneficiaryDOBLabel ", "text": msgs.beneficiaryDOB.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "beneficiaryDOBValue", "property": "beneficiaryDOB" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"beneficiaryHeightLabel ", "text": msgs.beneficiaryHeight.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "beneficiaryHeightValue", "property": "patientHeight" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"beneficiaryWeightLabel ", "text": msgs.beneficiaryWeight.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "beneficiaryWeightValue", "property": "patientWeight" , "size": { "xs": 12, "md": 10}}},
        ]
    },
    {
        title: {
            text: msgs.drugInformation.text,
            id: msgs.drugInformation.id
        },

        items: [
            {"label":{"id":"compoundDrugLabel ", "text": msgs.compoundDrugQuestion.text, "size": { "xs": 12, "md": 4 } }, "value": {"id": "compoundDrugValue", "type":"yesNo", "property": "isCompound" , "size": { "xs": 12, "md": 8}}},

            {"label":{"id":"drugNameLabel ", "text": msgs.drugName.text, "size": { "xs": 12, "md": 2 } }, toggleFn: isNotCompound,  "value": {"id": "drugNameValue", "property": "drugName" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"ndcLabel ", "text": msgs.drugNDC.text, "size": { "xs": 12, "md": 2 } }, toggleFn: isNDC,  "value": {"id": "ndc", "property": "ndc" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"drugFormLabel ", "text": "Drug Form:", "size": { "xs": 12, "md": 2 } },  toggleFn: isNotCompound, "value": {"id": "drugFormValue", "property": "drugForm" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"drugStrengthLabel ", "text": msgs.drugStrength.text, "size": { "xs": 12, "md": 2 } },  toggleFn: isNotCompound,  "value": {"id": "drugStrengthValue", "property": "drugStrength" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"quantityLabel ", "text": "Quantity:", "size": { "xs": 12, "md": 2 } }, toggleFn: isNotCompound, "value": {"id": "quantityValue", "property": "quantity" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"daysSupplyLabel ", "text": "Days Supply:", "size": { "xs": 12, "md": 2} }, toggleFn: isNotCompound, "value": {"id": "daysSupplyValue", "property": "daysSupply" , "size": { "xs": 12, "md": 4}}},


            {"label":{"id":"compoundDosageFormCdLabel ", "text": "Compound Dosage Form:", "size": { "xs": 12, "md": 2 } }, toggleFn: isCompound, "value": {"id": "compoundDosageFormCdValue", "property": "compoundDosageFormCd" ,  type: "option", "size": { "xs": 12, "md": 2}}},
            {"label":{"id":"compoundDispUnitFormIndLabel ", "text": "Compound Dispensing Unit Form Indicator:", "size": { "xs": 12, "md": 3} }, toggleFn: isCompound, "value": {"id": "compoundDispUnitFormIndValue", type: "option", "property": "compoundDispUnitFormInd" , "size": { "xs": 12, "md": 5}}},
            {"label":{"id":"compoundInformationLabel ", "text": "", "size": { "xs": 12, "md": 1 } }, toggleFn: isCompound, "value": {"id": "compoundInformationValue", "property": "compounds" ,  type: "compound", "size": { "xs": 12, "md": 11}}},
            
            {"label":{"id":"numberofAuthorizedRefillsLabel ", "text": msgs.numberofAuthorizedRefills.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "numberofAuthorizedRefillsValue", "property": "numberRefills" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"dawSelectionCodeLabel ", "text": msgs.dawSelectionCode.text, "size": { "xs": 12, "md": 2 } }, renderFn: dawCode, "value": {"id": "dawSelectionCodeValue", "property": "dawSelectionCode" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"requestTypeLabel ", "text": msgs.requestType.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "requestTypeValue", "property": "requestType" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"requestBeginDateLabel ", "text": msgs.requestBeginDate.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "requestBeginDateValue", "property": "requestBeginDate" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"requestEndDateLabel ", "text": msgs.requestEndDate.text, "size": { "xs": 12, "md": 2 } }, "value": {"id": "requestEndDateValue", "property": "requestEndDate" , "size": { "xs": 12, "md": 4}}},
            {"label":{"id":"diagnosisCodeLabel ", "text": msgs.diagnosisCode.text, "size": { "xs": 12, "md": 2 } }, renderFn: diagnosisCodes, "value": {"id": "diagnosisCodeValue", "property": "diagnosisCodes" , "size": { "xs": 12, "md": 10}}},
           ]
    },
    {
        title: {
            text: msgs.priorAuthInformation.text,
            id: msgs.priorAuthInformation.id
        },
        items: [
            {"label":{"id":"clinicalInformationLabel ", "text": msgs.clinicalInformation.text, "size": { "xs": 11, "md": 11 } }, toggleFn: isNotLegacy, "value": {"id": "clinicalInformationValue", "type":"noValue", "property": "" , "size": { "xs": 1, "md": 1}}},
            {"label":{"id":"additionalInformationLabel ", "text": msgs.additionalInformation.text, "size": { "xs": 12, "md": 12 } }, toggleFn: isNotLegacy, "value": {"id": "additionalInformationValue", "property": "additionalInformation" , "size": { "xs": 12, "md": 12}}},
            {"label":{"id":"trialFailureLabel ", "text": "Trial/Failure:", "size": { "xs": 12, "md": 12 } }, toggleFn: isLegacy, "value": {"id": "trialFailureValue", "property": "trialFailure" , "size": { "xs": 12, "md": 12}}},
            {"label":{"id":"clinicalInformationLabel ", "text": "Clinical Information:", "size": { "xs": 12, "md": 12 } }, toggleFn: isLegacy, "value": {"id": "clinicalInformationValue", "property": "clinicalInformation" , "size": { "xs": 12, "md": 12}}},
            {"label":{"id":"additionalInformationLabel ", "text": "Additional Information:", "size": { "xs": 12, "md": 12 } }, toggleFn: isLegacy, "value": {"id": "additionalInformationValue", "property": "additionalInformation" , "size": { "xs": 12, "md": 12}}},
        ]
    }
]
